import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionTypeIconMatching = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5 4.5H2C1.72386 4.5 1.5 4.72386 1.5 5V8C1.5 8.27614 1.72386 8.5 2 8.5H5C5.27614 8.5 5.5 8.27614 5.5 8V5C5.5 4.72386 5.27614 4.5 5 4.5Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 4.5H19C18.7239 4.5 18.5 4.72386 18.5 5V8C18.5 8.27614 18.7239 8.5 19 8.5H22C22.2761 8.5 22.5 8.27614 22.5 8V5C22.5 4.72386 22.2761 4.5 22 4.5Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 13.5H2C1.72386 13.5 1.5 13.7239 1.5 14V17C1.5 17.2761 1.72386 17.5 2 17.5H5C5.27614 17.5 5.5 17.2761 5.5 17V14C5.5 13.7239 5.27614 13.5 5 13.5Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 13.5H19C18.7239 13.5 18.5 13.7239 18.5 14V17C18.5 17.2761 18.7239 17.5 19 17.5H22C22.2761 17.5 22.5 17.2761 22.5 17V14C22.5 13.7239 22.2761 13.5 22 13.5Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 5L16 7L14 9",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 15C11.5 15 6.5 7 12 7H15",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 17L16 15L14 13",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 7C11.5 7 6.5 15 12 15H15",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	] })
});
export default SvgQuestionTypeIconMatching;
